import { checkAuth } from '@/apis';
import { EasyDrawContext } from '@/store';
import { observer } from 'mobx-react-lite';
import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from '@/pages/Welcome/Footer';

const prefixCls = 'chengzi8-app'
import './styles.less'

const DocumentLayout = observer(() => {
  const store = useContext(EasyDrawContext)
  const userStore = store.userStore
  const [isLogin, setIsLogin] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    checkAuth().then(res => {
      const { data = {}, code } = res
      if (!code && data.valid) {
        setIsLogin(true)
        userStore.queryUserInfo()
      }
    }).finally(() => { setLoading(false) })

  }, [])
  return (
    <div className={`${prefixCls}`}>
      <div className={`${prefixCls}_wrapper`} style={{ position: 'relative', minHeight: '100vh' }}>
        <Navbar isLogin={isLogin} loading={loading} className='doc_nav' />
        <div className="doc_wrapper">
          <Outlet context={{ loading, setLoading }} />
        </div>
        <Footer />
      </div>
    </div>
  )
})

export default DocumentLayout
